import { and, or } from 'tio-ui/utilities';
import { fn } from '@ember/helper';
import Modal from 'tio-reimagined/components/modal';
import Footer from 'tio-reimagined/components/footer';
import { t } from 'ember-intl';
import Textarea from 'tio-reimagined/components/textarea';
import type { Task } from 'ember-concurrency';
import Component from '@glimmer/component';

interface TioConfirmConfirmModalSignature {
  Args: {
    cancel: () => void;
    changelog: unknown;
    didSave?: () => void;
    hasSubmitted: boolean;
    modalBodyText?: string;
    modalTitle?: string;
    show: boolean;
    submitAction: Task<void, []>;
    submitButtonText: string;
    serverErrorMessages?: string[];
  };
}

export default class TioConfirmConfirmModalComponent extends Component<TioConfirmConfirmModalSignature> {
  submit = () => {
    try {
      this.args.submitAction.perform();
      this.args.cancel();
    } catch (error) {
      console.error(error);
    }
  };
  <template>
    <Modal @isOpen={{@show}} @onClose={{@cancel}}>
      <:header>{{@modalTitle}}</:header>
      <:body>
        <form>
          <h2>{{@modalBodyText}}</h2>
          <div>
            <Textarea
              @label={{t "common.reason"}}
              @value={{@changelog}}
              @onChange={{fn (mut @changelog)}}
              class="mb-4 w-full"
              required="true"
            />
          </div>
        </form>
        {{#if (and @hasSubmitted @serverErrorMessages.length)}}
          <ul class="text-red-600 my-2">
            {{#each @serverErrorMessages as |message|}}
              <li class="whitespace-normal">{{message}}</li>
            {{/each}}
          </ul>
        {{/if}}
      </:body>
      <:footer>
        <Footer
          @isRunning={{@submitAction.isRunning}}
          @onCancel={{@cancel}}
          @onSubmit={{this.submit}}
          @submitText={{or @submitButtonText (t "common.save")}}
        />
      </:footer>
    </Modal>
  </template>
}
